import React from 'react';
import { StandardQuote } from 'phoenix/constants/ReduxSelectors';
import { TradeTicketError } from './TradeTicketError';
import { Snex1LanguagePack } from 'phoenix/assets/lang/Snex1LanguagePack';
import { HasNumericValueGreaterThanZero } from 'util/Utils';
import { ApiTradeAction } from 'phoenix/models/ApiTradeRequest';
import { DisplayOrderType } from '../Store/TradeTicketViewModel';

interface ImmediateExecutionAdvisoryProps {
    action?: ApiTradeAction;
    limitPrice?: number | null;
    orderType?: DisplayOrderType;
    quote: StandardQuote;
    stopPrice?: number;
    text: Snex1LanguagePack['tradeTicket']['input']['advisories'];
}

export const ImmediateExecutionAdvisory = React.memo((props: ImmediateExecutionAdvisoryProps) => {
    const { orderType, quote, stopPrice = 0, action, text } = props;
    const limitPrice = props?.limitPrice ?? 0;
    const messages = text.immediateExecution;

    const isBuy = action === 'Buy';
    // A limit order only fills straight away if it reaches the far side of the spread. The last
    // trade is no guide: on a thinly traded option it often sits outside the current market.
    const touchPrice = Number(isBuy ? quote?.ask : quote?.bid) || 0;

    if (orderType === 'market') return null;
    else if (orderType === 'limit' && HasNumericValueGreaterThanZero(limitPrice) && HasNumericValueGreaterThanZero(touchPrice)) {
        if (isBuy && limitPrice >= touchPrice) return <TradeTicketError title={text.notice} message={messages.orderPriceError('limit', 'above-market')} />;
        if (!isBuy && limitPrice <= touchPrice) return <TradeTicketError title={text.notice} message={messages.orderPriceError('limit', 'below-market')} />;
    } else if (orderType === 'stoplimit' && HasNumericValueGreaterThanZero(limitPrice)) {
        if (isBuy && limitPrice > stopPrice) return <TradeTicketError title={text.notice} message={messages.stopLimitPriceError('above-stop')} />;
        if (!isBuy && limitPrice < stopPrice) return <TradeTicketError title={text.notice} message={messages.stopLimitPriceError('below-stop')} />;
    }

    return null;
});
